<template>
    <div class="problemSummary-wrapper">
        <div class="content">
            <div class="main">
                <div class="logo">
                    <img src="@/assets/images/big-logo.png" alt="">
                </div>
                <h1>我們與你同行，提供全面開店支援</h1>
            </div>
            <div @click="activateInput" class="search flex-start">
                <img src="@/assets/images/search-icon.png" class="icon" alt="">
                <input  ref="inputRef" type="text" placeholder="有甚麼疑問呢？" v-model="keywods" @input="inputChange">
                <img v-if="loading" class="loading" src="@/assets/images/loading.png" alt="">
                <div class="search-content" v-if="searchList && searchList.length">
                    <div @click="gototitle(item.title)" class="items" v-for="(item, index) in searchList" :key="index">{{
                        item.title }}</div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="list flex-bt">
                <div class="items flex-bt" v-for="(item, index) in list" :key="index">
                    <div class="img">
                        <img :src="item.image" alt="">
                    </div>
                    <div class="text flex-bt">
                        <div class="left">
                            <div class="name">{{ item.title }}</div>
                            <div class="tips">{{ item.tips }}</div>
                        </div>
                        <div class="right">
                            <img src="@/assets/images/bottom-icon.png" alt="">
                        </div>
                    </div>
                    <div class="small-menu" v-if="item.submenus && item.submenus.length">
                        <div @click="gotodetail(index)" class="child" v-for="(child, childIndex) in item.submenus"
                            :key="childIndex">
                            {{ child.submenutitle }}
                        </div>
                    </div>
                </div>
                <div class="items" style="height:0px;margin:0;background: none;"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            keywods: '',
            timer: null,
            searchList: [],
            searchallList: [],
            loading: false,
            list: [
                {
                    name: '產品專員',
                    tips: '新版本發佈通知',
                    menu: [
                        { path: '', name: '建立直播' },
                        { path: '', name: '商品中心' },
                        { path: '', name: '節目表' },
                        { path: '', name: '小幫手' },
                        { path: '', name: '直播設定' }
                    ]
                },
                {
                    name: '產品專員',
                    tips: '新版本發佈通知',
                    menu: [
                        { path: '', name: '建立直播' },
                        { path: '', name: '商品中心' },
                        { path: '', name: '節目表' },
                        { path: '', name: '小幫手' },
                        { path: '', name: '直播設定' }
                    ]
                },
                {
                    name: '產品專員',
                    tips: '新版本發佈通知',
                    menu: [
                        { path: '', name: '建立直播' },
                        { path: '', name: '商品中心' },
                        { path: '', name: '節目表' },
                        { path: '', name: '小幫手' },
                        { path: '', name: '直播設定' }
                    ]
                },
                {
                    name: '產品專員',
                    tips: '新版本發佈通知',
                    menu: [
                        { path: '', name: '建立直播' },
                        { path: '', name: '商品中心' },
                        { path: '', name: '節目表' },
                        { path: '', name: '小幫手' },
                        { path: '', name: '直播設定' }
                    ]
                }
            ]
        }
    },
    methods: {
		 activateInput() {
		      this.$refs.inputRef.focus();
		    },
        gotodetail(id) {
            this.$router.push('/resources?menu=' + id);
        },
        gototitle(title) {
			console.log(title)
            this.$router.push('/resources?wztitle=' + title);
        },
        async getList() {
            //http://loopw7.w7ad.com/app/index.php?i=3&c=entry&m=tvp_appcenter&do=helplist&sjk=helplist&onemulu=%E9%A0%BB%E9%81%93%E5%B0%88%E5%93%A1 
            let fdata = { do: 'helpmenu', sjk: 'helpsubmenu', orderby: 'id asc', limit: 10 }
            let res = await this.$api.funk(fdata)
            this.list = res
            console.log(res);

        },

        async getSearchList() {
            //http://loopw7.w7ad.com/app/index.php?i=3&c=entry&m=tvp_appcenter&do=helplist&sjk=helplist&onemulu=%E9%A0%BB%E9%81%93%E5%B0%88%E5%93%A1 
            let fdata = { do: 'searchTitleList', sjk: 'helpsubmenu', orderby: 'id asc', limit: 10 }
            let res = await this.$api.funk(fdata)
            this.searchallList = res
            console.log(res);

        },

        inputChange() {
            if (this.keywods) {
                this.loading = true
                clearTimeout(this.timer)
                this.timer = setTimeout(() => {
                    this.loading = false
                    this.search()
                }, 500)
            } else {
                this.searchList = []
                clearTimeout(this.timer)
            }
        },

        blur() {
            clearTimeout(this.timer)
            this.loading = false
            this.searchList = []
            this.keywods = ''
        },

        search() {
            this.searchList = []
            for (var i = 0; i < this.searchallList.length; i++) {
                //判断数据里面是否有符合輸入的内容  不符合返回-1 只需要大于或等于0就是符合
                if (this.searchallList[i].title.indexOf(this.keywods) >= 0) {
                    console.log(this.searchallList[i].title)
                    //然后把它丢进要展示的数组里面
                    this.searchList.push(this.searchallList[i])
                    //我这里是必选项为防止用户不選擇判断如有数据默認第一个

                }
            }
            console.log('searchlist', this.searchList);
        }
    },
    created(option) {
        this.getList()
        this.getSearchList()
    }
}
</script>
<style lang="scss" scoped>
.problemSummary-wrapper {
    .list {
        align-items: inherit;
        padding-top: 1rem;
        flex-wrap: wrap;
        position: relative;
        z-index: 10;

        .items {
            width: 4.04rem;
            height: 1.72rem;
            background: #F5FAFA;
            border-radius: 0.24rem;
            margin-bottom: 0.4rem;
            position: relative;
            padding: 0.24rem;
            cursor: pointer;

            &:hover {
                .small-menu {
                    display: block;
                }

                .right {
                    transform: rotate(180deg);
                }
            }

            .small-menu {
                position: absolute;
                width: 100%;
                left: 0;
                top: 1.72rem;
                background: #F5FAFA;
                box-shadow: 0px 0.04rem 0.08rem rgba(0, 0, 0, 0.32);
                border-radius: 0.24rem;
                padding: 0.08rem;
                display: none;
                transition: all .6s;
                z-index: 90;

                .child {
                    width: 100%;
                    height: 0.64rem;
                    border-radius: 0.16rem;
                    font-family: 'PingFang HK';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.2rem;
                    line-height: 0.64rem;
                    color: #000000;
                    cursor: pointer;
                    padding: 0 0.16rem;
                    transition: all .6s;

                    &:hover {
                        background: #FFFFFF;

                    }
                }
            }

            .img {
                width: 1.24rem;
                height: 1.24rem;
                margin-right: 0.16rem;

                img {
                    width: 100%;
                    height: 100%;
                    display: block;
                }
            }

            .text {
                flex: 1;

                .right {
                    width: 0.18rem;
                    transition: all .6s;

                    img {
                        width: 100%;
                        display: block;
                    }
                }

                .left {
                    .name {
                        font-family: 'PingFang HK';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 0.24rem;
                        line-height: 0.34rem;
                        color: #000000;
                    }

                    .tips {
                        margin-top: 0.08rem;
                        font-family: 'PingFang HK';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 0.16rem;
                        line-height: 0.22rem;
                        color: #666666;
                    }
                }
            }
        }
    }

    .content {
        width: 100%;
        height: 3.4rem;
        background: url('~@/assets/images/commerceClassroom-bgs.png')no-repeat center center /100% 100%;
        padding-top: 0.86rem;
        position: relative;

        .search {
            width: 8.4rem;
            height: 0.72rem;
            background: #FAFAFA;
            border: 1px solid #999999;
            box-shadow: 0px 0.04rem 0.08rem rgba(0, 0, 0, 0.25);
            border-radius: 0.08rem;
            margin: 0 auto;
            position: absolute;
            left: 0;
            right: 0;
            bottom: -0.36rem;
            padding: 0 0.24rem;
            font-family: 'PingFang HK';
            font-style: normal;
            font-weight: 400;
            font-size: 0.24rem;
            line-height: 0.24rem;
            text-align: left;
            color: #808080;
            padding-right: 0.6rem;


            .search-content {
                position: absolute;
                top: 0.72rem;
                left: 0;
                width: 100%;
                background: #FAFAFA;
                border-top: 0;
                border-bottom-left-radius: 0.08rem;
                border-bottom-right-radius: 0.08rem;
                // height: 4rem;
                width: 100%;
                z-index: 90;
                overflow: auto;
                box-shadow: 0px 0.04rem 0.08rem rgba(0, 0, 0, 0.25);
                padding: 0.3rem 0.1rem;

                .items {
                    width: 100%;
                    height: 0.8rem;
                    padding: 0 0.2rem;
                    line-height: 0.8rem;
                    border-bottom: 1px solid #cecece;
                    cursor: pointer;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    color: #000000;
                    font-size: 0.2rem;
                    transition: all .6s;

                    &:hover {
                        background: #e7e8e8;
                    }

                }
            }

            input {
                flex: 1;
                background: none;
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.24rem;
                text-align: left;
                color: #000000;

                &::placeholder {
                    color: #808080;
                }
            }

            .icon {
                width: 0.24rem;
                height: 0.24rem;
                display: block;
                margin-right: 0.16rem;
            }

            .loading {
                position: absolute;
                top: 0;
                bottom: 0;
                margin: auto 0;
                right: 0.3rem;
                width: 0.3rem;
                height: 0.3rem;
                animation: load 1.1s infinite linear;
            }

            @keyframes load {
                from {
                    transform: rotate(0deg);
                }

                to {
                    transform: rotate(360deg);
                }
            }

        }

        .logo {
            height: 0.8rem;
            width: 1.74rem;
            margin: 0 auto;

            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }

        h1 {
            width: 100%;
            text-align: center;
            font-family: 'PingFang HK';
            font-style: normal;
            font-weight: 600;
            font-size: 0.32rem;
            line-height: 0.45rem;
            letter-spacing: 0.05em;
            color: #000000;
            margin-top: 0.33rem;
        }
    }
}

@media (max-width: 750px) {
    .problemSummary-wrapper .content .search {
        width: 6.8rem;
    }

    .problemSummary-wrapper .list {
        display: block;
    }

    .problemSummary-wrapper .list .items {
        width: 96%;
        margin: 0 auto;
        margin-bottom: 0.4rem;
        height: auto;
    }

    .problemSummary-wrapper .list .items .img {
        width: 1.8rem;
        height: 1.8rem;
    }

    .problemSummary-wrapper .list .items .text .left .name {
        font-size: 0.32rem;
        line-height: 0.32rem;
    }

    .problemSummary-wrapper .list .items .text .left .tips {
        margin-top: 0.2rem;
        font-size: 0.2rem;
        line-height: 0.2rem;
    }

    .problemSummary-wrapper .list .items .small-menu {
        top: 2.2rem;
    }

    .problemSummary-wrapper .list .items .small-menu .child {
        font-size: 0.3rem;
    }
}
</style>